import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import IUIActions from "../IUIActions";
import userActionInstance, {ACTION_EVENTS} from "../UserAction";
import MobileDOM from "./MobileDOM";
import AbstractUI from "../AbstractUI";
import AbstractUIScreen from "../screen/AbstractUIScreen";
import MobileUIController from "./MobileUIController";
import AudioController from "../AudioController";

@injectable()
export default class MobileUI extends AbstractUI {

    public dom: MobileDOM;
    public uiController: MobileUIController;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.DOM) dom: MobileDOM,
        @inject(SERVICE_IDENTIFIER.UIController) uiController: MobileUIController,
        @inject(SERVICE_IDENTIFIER.UIActions) uiActions: IUIActions,
        @inject(SERVICE_IDENTIFIER.UIScreen) uiScreen: AbstractUIScreen,
        @inject(SERVICE_IDENTIFIER.AudioController) audioController: AudioController
    ) {
        super(config, dom, uiActions, uiScreen, audioController);
        this.dom = dom;
        this.uiController = uiController;
    }

    create() {
        super.create();

        this.dom.betSlider.on("set", val => userActionInstance.trigger(ACTION_EVENTS.ACTION_SLIDER_BET_ON_SET, val));
        this.dom.coinSlider.on("set", val => userActionInstance.trigger(ACTION_EVENTS.ACTION_SLIDER_COIN_ON_SET, val));
        this.dom.linesSlider.on("set", val => userActionInstance.trigger(ACTION_EVENTS.ACTION_SLIDER_LINES_ON_SET, val));

        this.uiController.create();

        $("#wrapper").addClass("device-mobile");
    }
}